/* Router */
import { useParams, useSearchParams } from "react-router-dom"


/*
    Helper withRouter
*/
const withRouter = (Component) => {

    const Wrapper = (props) => {

        const params = useParams()
        const [search] = useSearchParams()

        return (
            <Component
                params={params}
                search={search}
                {...props}
            />
        )
    }

    return Wrapper
}


export default withRouter
